<div class="flex-column-content">
  <div>
    <!-- TODO (jacob): This renders incorrectly if the screen size is less than 819px -->
    <div>
      {{ this.title }}
    </div>
  </div>
  <!-- TODO (jacob): This renders incorrectly if the screen size is less than 998px -->
  <div>
    <ng-container [ngTemplateOutlet]="body"></ng-container>
  </div>
  <div>
    <ng-container [ngTemplateOutlet]="footer"></ng-container>
  </div>
</div>
